import WelcomeForm from './WelcomeForm';

export default WelcomeForm;
